import { render } from "./TicketsDelayed.vue?vue&type=template&id=4ff03904&scoped=true&ts=true"
import script from "./TicketsDelayed.vue?vue&type=script&lang=ts"
export * from "./TicketsDelayed.vue?vue&type=script&lang=ts"

import "./TicketsDelayed.vue?vue&type=style&index=0&id=4ff03904&scoped=true&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff03904"]])

export default __exports__